export default {
    encoding: [
        {
            name: 'x',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the x-axis.',
            defaultValue: 'primary[0]',
            isRequired: 'true',
        },
        {
            name: 'y',
            type: '[number | string]',
            desc: 'Specify the dataSource applied to the y-axis.',
            defaultValue: 'primary[1]',
            isRequired: 'true',
        },
        {
            name: 'category',
            type: '[number | string]',
            desc: 'Specify a sequence of dataSource events to be plotted on the chart.',
            isRequired: 'false',
        },
        {
            name: 'size',
            type: '[number | string]',
            desc: 'Specify the dataSource events that are represented by the bubble size in the chart.',
            defaultValue: 'primary[2]',
            isRequired: 'true',
        },
    ],
    events: [
        {
            name: 'point.click',
            desc: 'trigger when user clicks a data point',
        },
        {
            name: 'legend.click',
            desc: 'trigger when user clicks a chart legend',
        },
    ],
};
